const updateSites = {
  toastr: 'Sitio actualizado',
  toastr1: ' fue actualizado con éxito',
  toastrError: 'Sitio ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default updateSites;
